export default "__VITE_ASSET__DOuqPOj4__"